import * as YupImp from 'yup';
import {yupCs} from './yup-cs';

YupImp.setLocale(yupCs);
export const Yup = YupImp;
